import { lazy } from 'react';

const DashboardPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/adm/parameters/dashboard',
			component: lazy(() => import('./DashboardPage'))
		}
	]
};

export default DashboardPageConfig;